import { SCENE_REGISTRY, type SceneRegistryEntryOf } from './sceneRegistry';

/**
 * Phaser scene keys, derived from `SCENE_REGISTRY`. Every scene registers under the key
 * matching its entry here, and all navigation references these constants instead
 * of bare strings — so a mistyped or renamed scene is a compile error, and there
 * is a single place to see the whole scene graph.
 */
export const SCENE_KEYS = Object.fromEntries(
  SCENE_REGISTRY.map((entry) => [entry.id, entry.key]),
) as { [Entry in SceneRegistryEntryOf as Entry['id']]: Entry['key'] };

export type SceneKey = (typeof SCENE_KEYS)[keyof typeof SCENE_KEYS];
